import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "outer"
}
const _hoisted_2 = { class: "left-pane" }
const _hoisted_3 = { class: "right-pane" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!

  return (_ctx.config && _ctx.sconfig)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createVNode(_component_XLoadingIcon, { class: "loading-icon" }, null, 512), [
          [_vShow, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (c) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(c), {
              id: c.name,
              key: c.name,
              status: _ctx.status,
              config: _ctx.config,
              sconfig: _ctx.sconfig,
              onUpdate: _ctx.update
            }, null, 40, ["id", "status", "config", "sconfig", "onUpdate"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (c) => {
            return (_openBlock(), _createElementBlock("a", {
              class: "sec-link",
              key: c.name,
              href: `#${c.name}`
            }, _toDisplayString(c.title ?? c.name), 9, _hoisted_4))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}